import BigPicture from 'bigpicture';
import $ from 'jquery';

// This jQuery function handles:
// - The auto-refreshing content (Milestones image & Latest updates)
// - The triggering of all lightboxes (left & right columns)

$(function() {

  function handleLightboxes() {
    // Handle lightbox > anchor to image:
    const laiItems = document.querySelectorAll('.lightbox-anchor-image');
    Array.prototype.forEach.call(laiItems, function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          imgSrc: e.target.getAttribute('href'),
        })
      })
    });

    // Handle lightbox > anchor to video:
    const lavItems = document.querySelectorAll('.lightbox-anchor-video');
    Array.prototype.forEach.call(lavItems, function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          vidSrc: e.target.getAttribute('href'),
        })
      })
    });

    // Handle lightbox > video element:
    const lveItems = document.querySelectorAll('.lightbox-video-el');
    Array.prototype.forEach.call(lveItems, function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        BigPicture({
          el: e.target,
          vidSrc: e.target.querySelector('source').getAttribute('src')
        })
      })
    });
  }

  function handleContentRefreshing() {
    $('#milestones').load('milestones.html');
    $('#latest-updates').load('latest-updates.html', handleLightboxes);
  }

  // Run the handleLightboxes function once, immediately…

  handleLightboxes();
  
  // Run the handleContentRefreshing function once, immediately…

  handleContentRefreshing();

  // …and re-run handleContentRefreshing every 60 seconds

  setInterval(handleContentRefreshing, 60000);

});


// The below functions handle mobile-only columm tabs; heavily borrowed from
// https://inclusive-components.design/tabbed-interfaces/

let tabList = document.querySelector('.column-tabs');

if (tabList) {
  let tabs = tabList.querySelectorAll('a');
  let column = document.querySelectorAll('[id^="column"]');

  function createColumnTabs() {

    const switchTab = (oldTab, newTab) => {
      newTab.focus();
      newTab.removeAttribute('tabindex');
      newTab.setAttribute('aria-selected', 'true');
      oldTab.removeAttribute('aria-selected');
      oldTab.setAttribute('tabindex', '-1');
      let index = Array.prototype.indexOf.call(tabs, newTab);
      let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
      column[oldIndex].hidden = true;
      column[index].hidden = false;
    }

    tabList.setAttribute('role', 'tabList');

    Array.prototype.forEach.call(tabs, (tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('id', 'tab' + (i + 1));
      tab.setAttribute('tabindex', '-1');
      tab.parentNode.setAttribute('role', 'presentation');

      tab.addEventListener('click', e => {
        e.preventDefault();
        let currentTab = tabList.querySelector('[aria-selected]');
        if (e.currentTarget !== currentTab) {
          switchTab(currentTab, e.currentTarget);
        }
      });
    });

    Array.prototype.forEach.call(column, (panel, i) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '-1');
      let id = panel.getAttribute('id');
      panel.setAttribute('aria-labelledby', tabs[i].id);
      panel.hidden = true;
    });

    tabs[0].removeAttribute('tabindex');
    tabs[0].setAttribute('aria-selected', 'true');
    tabs[1].setAttribute('aria-selected', 'false');
    column[0].hidden = false;

  };

  function destroyColumnTabs() {
    tabList.removeAttribute('role');
    Array.prototype.forEach.call(column, (panel, i) => {
      panel.removeAttribute('role');
      panel.removeAttribute('tabindex');
      panel.removeAttribute('aria-labelledby');
      panel.hidden = false;
    });
  }

  // Set up our own window resize listener that's based on
  // requestAnimationFrame because it's so dang performant
  (function betterResizeListener() {
    let running = false;
    function doItViaRAF() {
        if (running) { return; }
        running = true;
        requestAnimationFrame(function() {
            window.dispatchEvent(new CustomEvent('betterResize'));
            running = false;
        })
    }
    window.addEventListener('resize', doItViaRAF);
  })();

  window.addEventListener('betterResize', function() {
    let vpWidth = window.innerWidth;

    if (vpWidth < 768) {
      createColumnTabs();
    } else {
      destroyColumnTabs();
    }
  }, false);

  window.dispatchEvent(new CustomEvent('betterResize'));
}